import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=615a145b&"
import script from "./FlashMessage.vue?vue&type=script&lang=ts&"
export * from "./FlashMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615a145b')) {
      api.createRecord('615a145b', component.options)
    } else {
      api.reload('615a145b', component.options)
    }
    module.hot.accept("./FlashMessage.vue?vue&type=template&id=615a145b&", function () {
      api.rerender('615a145b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FlashMessage.vue"
export default component.exports